import actions from "../actionTypes/bookingSetup";

export const addContractTypes = data => ({
  type: actions.ADD_CONTRACT_TYPE,
  data
});

export const updateContractTypes = data => ({
  type: actions.UPDATE_CONTRACT_TYPE,
  data
});

export const deleteContractTypes = data => ({
  type: actions.DELETE_CONTRACT_TYPE,
  data
});

export const getQualificationTitleList = () => ({
  type: actions.GET_QUALIFICATION_LIST
});
export const addQualifications = data => ({
  type: actions.ADD_QUALIFICATION_TYPE,
  data
});

export const deleteQualification = data => ({
  type: actions.DELETE_QUALIFICATION_TYPE,
  data
});

export const updateQualification = data => ({
  type: actions.UPDATE_QUALIFICATION_ENTRY,
  data
});

export const getUserList = data => ({
  type: actions.GET_USERLIST,
  data
});

export const getContractTypeList = () => ({
  type: actions.GET_CONTRACT_TYPE_LIST
});

export const getUserGroupList = () => ({
  type: actions.GET_GROUP_USERS_LIST
});

export const deleteUserGroup = data => ({
  type: actions.DELETE_USER_GROUP,
  data
});

export const addNewUserGroup = data => ({
  type: actions.ADD_USER_GROUP,
  data
});

export const getBookingExpenseTypes = () => ({
  type: actions.GET_EXPENSE_TYPE_BOOKING
});

export const addBookingExpenseType = data => ({
  type: actions.ADD_NEW_BOOKING_EXPENSE,
  data
});

export const deleteBookingExpenseType = data => ({
  type: actions.DELETE_BOOKING_EXPENSE_TYPE,
  data
});

export const getTags = () => ({
  type: actions.GET_TAG_NAME
});

export const deleteTag = data => ({
  type: actions.DELETE_TAG_NAME,
  data
});

export const createTag = data => ({
  type: actions.CREATE_TAG_NAME,
  data
});

export const updateTag = data => ({
  type: actions.UPDATE_TAG_NAME,
  data
});

export const getCandidateRatingTypeList = () => ({
  type: actions.GET_CANDIDATE_RATING_TYPES
});

export const deleteCandidateRatingType = data => ({
  type: actions.DELETE_CANDIDATE_RATING_TYPES,
  data
});

export const addCandidateRatingType = data => ({
  type: actions.ADD_CANDIDATE_RATING_TYPES,
  data
});

export const updateCandidateRatingType = data => ({
  type: actions.UPDATE_CANDIDATE_RATING_TYPES,
  data
});

export const updateBookingExpenseType = data => ({
  type: actions.UPDATE_EXPENSE_TYPES,
  data
});

export const updateUserGroup = data => ({
  type: actions.UPDATE_GROUP_NAME,
  data
});

export const getCandidateInfringementTypeList = () => ({
  type: actions.GET_INFRINGEMENT_TYPE
});

export const deleteCandidateInfringementType = data => ({
  type: actions.DELETE_INFRINGEMENT_TYPE,
  data
});

export const addNewCandidateInfringementType = data => ({
  type: actions.ADD_INFRINGEMENT_TYPE,
  data
});

export const updateCandidateInfringementType = data => ({
  type: actions.UPDATE_INFRINGEMENT_TYPE,
  data
});

export const getCandidatePerformanceTypeList = () => ({
  type: actions.GET_PERFORMANCE_TYPES
});

export const deleteCandidatePerformanceType = data => ({
  type: actions.DELETE_PERFORMANCE_TYPES,
  data
});

export const addCandidatePerformanceType = data => ({
  type: actions.ADD_PERFORMANCE_TYPES,
  data
});

export const updateCandidatePerformanceType = data => ({
  type: actions.UPDATE_PERFORMANCE_TYPES,
  data
});

export const getNonConversionReasonList = () => ({
  type: actions.GET_NON_CONVERSION_LIST
});

export const getInsuranceCategoryList = () => ({
  type: actions.GET_INSURANCE_CATEGORY_LIST
});

export const deleteInsuranceCategoryType = data => ({
  type: actions.DELETE_INSURANCE_CATEGORY,
  data
});

export const addInsuranceCategoryType = data => ({
  type: actions.ADD_INSURANCE_CATEGORY,
  data
});

export const updateInsuranceCategoryType = data => ({
  type: actions.UPDATE_INSURANCE_CATEGORY,
  data
});

export const getLeadSourceList = () => ({
  type: actions.GET_LEAD_SOURCE_TYPES
});

export const addNonConversionReasonType = data => ({
  type: actions.ADD_NON_CONVERSION_TYPE,
  data
});

export const updateNonConversionReasonType = data => ({
  type: actions.UPDATE_NON_CONVERSION_TYPE,
  data
});

export const deleteNonConversionReasonType = data => ({
  type: actions.DELETE_NON_CONVERSION_TYPE,
  data
});

export const addLeadSourceType = data => ({
  type: actions.ADD_LEAD_SOURCE_TYPES,
  data
});

export const updateLeadSourceType = data => ({
  type: actions.UPDATE_LEAD_SOURCE_TYPE,
  data
});

export const deleteLeadSourceType = data => ({
  type: actions.DELETE_LEAD_SOURCE_TYPES,
  data
});

export const getReasonForLeavingList = () => ({
  type: actions.GET_LEAVING_REASON_TYPE
});

export const addLeavingReasonType = data => ({
  type: actions.ADD_LEAVING_REASON_TYPE,
  data
});

export const updateLeavingReasonType = data => ({
  type: actions.UPDATE_LEAVING_REASON_TYPE,
  data
});

export const deleteLeavingReasonType = data => ({
  type: actions.DELETE_LEAVING_REASON_TYPE,
  data
});

export const updateBankHoliday = data => ({
  type: actions.UPDATE_BANK_HOLIDAY,
  data
});

export const deleteBankHoliday = data => ({
  type: actions.DELETE_BANK_HOLIDAY,
  data
});

export const getBankHolidayList = () => ({
  type: actions.GET_BANK_HOLIDAY
});

export const getBookingType = () => ({
  type: actions.GET_BOOKING_TYPE
});

export const getMessageTemplates = () => ({
  type: actions.GET_MESSAGE_TEMPLATES
});

export const deleteMessageTemplateAttachment = data => ({
  type: actions.DELETE_MESSAGE_TEMPLATE_ATTACHMENT,
  data
});

export const downloadTemplateAttachment = data => ({
  type: actions.DOWNLOAD_TEMPLATE_ATTACHMENT,
  data
});

export const clearDeleteMessageTemplateAttachment = () => ({
  type: actions.DELETE_MESSAGE_TEMPLATE_ATTACHMENT_CLEAR
});

export const clearDownloadMessageTemplateAttachment = () => ({
  type: actions.DOWNLOAD_TEMPLATE_ATTACHMENT_CLEAR
});

export const getTemplateFields = () => ({
  type: actions.GET_TEMPLATE_FIELDS
});

export const updateMessageTemplate = data => ({
  type: actions.UPDATE_MESSAGE_TEMPLATE,
  data
});

export const sendMessageTemplateEmail = data => ({
  type: actions.SEND_MESSAGE_TEMPLATE_EMAIL,
  data
});

export const clearSendMessageTemplateEmail = () => ({
  type: actions.SEND_MESSAGE_TEMPLATE_EMAIL_CLEAR
});

export const clearUpdateMessageTemplate = () => ({
  type: actions.UPDATE_MESSAGE_TEMPLATE_CLEAR
});

export const deleteMessageTemplate = data => ({
  type: actions.DELETE_MESSAGE_TEMPLATE,
  data
});

export const clearDeleteMessageTemplate = () => ({
  type: actions.DELETE_MESSAGE_TEMPLATE_CLEAR
});

export const addMessageTemplate = data => ({
  type: actions.ADD_MESSAGE_TEMPLATE,
  data
});

export const clearAddMessageTemplate = () => ({
  type: actions.ADD_MESSAGE_TEMPLATE_CLEAR
});

export const addBookingType = data => ({
  type: actions.ADD_BOOKING_TYPE,
  data
});

export const updateBookingType = data => ({
  type: actions.UPDATE_BOOKING_TYPE,
  data
});

export const getServiceCompanyList = () => ({
  type: actions.GET_SERVICE_COMPANIES
});

export const getIdentificationNameList = () => ({
  type: actions.GET_IDENTIFICATION_NAME_LIST
});

export const addBankHoliday = data => ({
  type: actions.ADD_BANK_HOLIDAY,
  data
});

export const deleteBookingType = data => ({
  type: actions.DELETE_BOOKING_TYPE,
  data
});

export const addNewIdentification = data => ({
  type: actions.ADD_IDENTIFICATION_NAME_LIST,
  data
});

export const updateIdentification = data => ({
  type: actions.UPDATE_IDENTIFICATION_TYPE,
  data
});

export const deleteIdentification = data => ({
  type: actions.DELETE_IDENTIFICATION_TYPE,
  data
});

export const getPhoneNumbersList = data => ({
  type: actions.GET_PHONE_NUMBER_LIST,
  data
});

export const getClientDocumentTypeList = () => ({
  type: actions.GET_CLIENT_DOCUMENT_LIST
});

export const addClientDocumentType = data => ({
  type: actions.ADD_CLIENT_DOCUMENT,
  data
});

export const updateClientDocumentType = data => ({
  type: actions.UPDATE_CLIENT_DOCUMENT,
  data
});

export const deleteClientDocumentType = data => ({
  type: actions.DELETE_CLIENT_DOCUMENT,
  data
});

export const getContactDetails = data => ({
  type: actions.GET_CONTACT,
  data
});

export const addServiceCompany = (payload, Name) => ({
  type: actions.ADD_SERVICE_COMPANY,
  payload,
  Name
});

export const updateServiceCompany = payload => ({
  type: actions.UPDATE_SERVICE_COMPANY,
  payload
});

export const deleteServiceCompany = payload => ({
  type: actions.DELETE_SERVICE_COMPANY,
  payload
});

export const getStartDay = () => ({
  type: actions.GET_START_DAY
});

export const sendPayDocuments = data => ({
  type: actions.SEND_PAY_EMAIL,
  data
});

export const getAllSiteList = () => ({
  type: actions.GET_ALL_SITES
});

export const getAllSiteListPaged = data => ({
  type: actions.GET_ALL_SITES_PAGED,
  data
});

export const duplicateSite = data => ({
  type: actions.DUPLICATE_SITE,
  data
});

export const clearDuplicateSite = () => ({
  type: actions.DUPLICATE_SITE_CLEAR
});

export const deleteBookingTypeClear = () => ({
  type: actions.DELETE_BOOKING_TYPE_CLEAR
});

export const ClearsendPayDocuments = () => ({
  type: actions.SEND_PAY_EMAIL_CLEAR
});

export const getAllReasonCodes = () => ({
  type: actions.GET_ALL_REASON_CODES
});

export const getAllMobileAppLinks = () => ({
  type: actions.GET_ALL_MOBILE_APP_LINKS
});

export const addReasonCode = data => ({
  type: actions.ADD_REASON_CODE,
  data
});

export const updateReasonCode = data => ({
  type: actions.UPDATE_REASON_CODE,
  data
});

export const clearUpdateReasonCode = () => ({
  type: actions.UPDATE_REASON_CODE_CLEAR
});

export const addMobileAppLink = data => ({
  type: actions.ADD_MOBILE_APP_LINK,
  data
});

export const clearAddMobileAppLink = data => ({
  type: actions.ADD_MOBILE_APP_LINK_CLEAR,
  data
});

export const clearAddReasonCode = data => ({
  type: actions.ADD_REASON_CODE_CLEAR,
  data
});

export const clearDeleteReasonCode = () => ({
  type: actions.DELETE_REASON_CODE_CLEAR
});

export const updateMobileAppLink = data => ({
  type: actions.UPDATE_MOBILE_APP_LINK,
  data
});

export const clearUpdateMobileAppLink = data => ({
  type: actions.UPDATE_MOBILE_APP_LINK_CLEAR,
  data
});

export const deleteMobileAppLink = data => ({
  type: actions.DELETE_MOBILE_APP_LINK,
  data
});

export const deleteReasonCode = data => ({
  type: actions.DELETE_REASON_CODE,
  data
});

export const listAssignmentDetailsTemplate = () => ({
  type: actions.LIST_ASSIGNMENT_DETAILS_TEMPLATE
});

export const saveAssignmentDetailsTemplate = payload => ({
  type: actions.SAVE_ASSIGNMENT_DETAILS_TEMPLATE,
  payload
});

export const clearSaveAssignmentDetailsTemplate = () => ({
  type: actions.SAVE_ASSIGNMENT_DETAILS_TEMPLATE_CLEAR
});

export const deleteAssignmentDetailsTemplate = payload => ({
  type: actions.DELETE_ASSIGNMENT_DETAILS_TEMPLATE,
  payload
});

export const clearDeleteAssignmentDetailsTemplate = () => ({
  type: actions.DELETE_ASSIGNMENT_DETAILS_TEMPLATE_CLEAR
});

export const clearDeleteMobileAppLink = data => ({
  type: actions.DELETE_MOBILE_APP_LINK_CLEAR,
  data
});
